<div class="club-socio-page">
  <app-title-page [title]="title" icon="uk-icon-shopping-cart"></app-title-page>
  <app-payment-visa-response-authorization
    [transactionId]="transactionId"
    [transactionToken]="transactionToken"
  ></app-payment-visa-response-authorization>
</div>
